import React, {Component} from 'react';
import './../../../styles/gallery.css';
import Gallery from 'react-grid-gallery';
import WithOutPictures from './../../../components/shared/without-photos';
import {INSPECTION_STATE_CODE} from '../../../constants/app/inspection';

class GalleryCar extends Component {
    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.images.length) {
            setTimeout(() => {
                const listImgs = document.querySelectorAll('div[title="Select"]');
                if (listImgs.length) {
                    listImgs.forEach((i) => {
                        i.setAttribute("title", "Selecciona")
                    })
                }
            }, 500)
        }
    }

    componentDidMount() {
        setTimeout(() => {
            const listImgs = document.querySelectorAll('div[title="Select"]');
            if (listImgs.length) {
                listImgs.forEach((i) => {
                    i.setAttribute("title", "Selecciona")
                })
            }
        }, 500)
    }

    render() {
        const {
            images = [], title = '', message = '', handleSelect = () => {
            }, picturesObserveds = [], allImages = [], inspection = {}
        } = this.props;

        let imagesTransform = [];
        imagesTransform = images.map((img, index) => {
            if (inspection.state && inspection.state.inspectionStatus && (inspection.state.inspectionStatus === INSPECTION_STATE_CODE.RETURN)) {
                picturesObserveds && picturesObserveds.forEach(pic => {
                    if (img.id === pic.attachedId) {
                        img.isSelected = true;
                    }
                    return img;
                })
            }
            img.customOverlay = (
                <div className="customImg" key={index}>
                    <div>{img.caption}</div>
                </div>
            );
            return img;
        });

        return (
            <div className="main-gallery">
                {
                    imagesTransform.length > 0 ?
                        <Gallery
                            images={imagesTransform}
                            enableImageSelection={true}
                            imageCountSeparator=" de "
                            onSelectImage={handleSelect}
                            rowHeight={155}
                        />
                        :
                        <WithOutPictures typePictures={title} message={message} imagesTransform={imagesTransform}/>
                }
            </div>
        )
    }
}

export default GalleryCar;



// WEBPACK FOOTER //
// ./src/components/shared/gallery/index.js